import { MethodTypes } from '@heimdallr-sdk/types';
import { obj2query } from './base';
export function beacon(url, data) {
    var formData = new FormData();
    Object.keys(data).forEach(function (key) {
        var value = data[key];
        if (typeof value !== 'string') {
            value = JSON.stringify(value);
        }
        formData.append(key, value);
    });
    return navigator.sendBeacon(url, formData);
}
export function get(url, data) {
    return xhr(MethodTypes.GET, "".concat(url).concat(url.indexOf('?') === -1 ? '?' : '').concat(obj2query(data)), '');
}
export function post(url, data) {
    return xhr(MethodTypes.POST, url, obj2query(data));
}
export function xhr(method, url, data) {
    return new Promise(function (rs, rj) {
        try {
            var xhr_1 = new XMLHttpRequest();
            xhr_1.open(method, url);
            xhr_1.setRequestHeader('Content-Type', 'application/json;charset=UTF-8');
            if (method === MethodTypes.POST) {
                xhr_1.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');
                xhr_1.send(data);
            }
            else {
                xhr_1.send();
            }
            xhr_1.onreadystatechange = function () {
                if (xhr_1.readyState == XMLHttpRequest.DONE && xhr_1.status == 200) {
                    rs(JSON.parse(xhr_1.response));
                }
                else {
                    new Error(xhr_1.response);
                }
            };
        }
        catch (error) {
            rj(error);
        }
    });
}
export function imgRequest(url, data) {
    var img = new Image();
    var spliceStr = url.indexOf('?') === -1 ? '?' : '&';
    img.src = "".concat(url).concat(spliceStr, "data=").concat(encodeURIComponent(JSON.stringify(data)));
    img = null;
}
